<template>
  <div>
    <!-- 产品充值 -->
    <div class="product-pay-title">请选择充值金额</div>
    <!-- 充值金额选择 -->
    <div class="product-pay-money">
      <div
        :class="['product-pay-money-list',item.id==activeIndex?'active':'']"
        v-for="(item,index) in rechargeAmount"
        :key="index"
        :data-money="item.price"
        @click="handleSelectMoney(item.id,$event)"
      >{{item.price}}</div>
      <div class="product-pay-money-list" @click="handleSelectCustomMoney(5,$event)">
        <input v-reset-page  type="number" pattern="[0-9]*" oninput="if(value.length>5)value=value.slice(0,5)" @input="inputChange" placeholder="自定义金额" v-model="customMoney"/>
      </div>
    </div>
    <!-- 支付金额 -->
    <div class="product-pay-show-money" v-show="!customMoney">
      支付金额：
      <span>￥</span>
      <span>{{money}}</span>
    </div>
    <div class="product-pay-show-money" v-show="customMoney">
      支付金额：
      <span>￥</span>
      <span>{{customMoney}}</span>
    </div>
    <!-- 支付按钮 -->
    <div class="pay-btn" @click="handleClickPay">立即支付</div>
    <!-- 支付提示 -->
    <div class="pay-tip">*支付完成后，财务工作人员将会在3天充值对应金额至您的网吧账户</div>
  </div>
</template>
<script>
import { payRecharge, pay, payState } from "@/api/pay";
import wx from "weixin-js-sdk";
import { Toast, Loading } from "vant"
export default {
  data() {
    return {
      rechargeAmount: [],
      activeIndex: "",
      money: "",
      customMoney: ""
    };
  },
  mounted() {
    if (window.location.href.indexOf("?#") < 0) {
      window.location.href = window.location.href.replace("#", "?#");
    }
    console.log(wx);
    this.requestPayRecharge();

  },
  methods: {
    inputChange(e) {
      console.log(e)
        if (!(/^[1-9]\d*$/).test(this.customMoney)) {
             this.customMoney = ""
        }
    },
    // 选择点中加背景颜色
    handleSelectMoney(index, event) {
      console.log(index);
      console.log(event);
      this.activeIndex = index;
      this.money = event.target.dataset.money;
      if(this.customMoney) {
        this.customMoney = ""
      }
    },
    // 选择自定义金额
    handleSelectCustomMoney(index) {
      this.activeIndex = index;
 
    },
    requestPayRecharge() {
      payRecharge().then(res => {
        console.log(res);
        this.rechargeAmount = res.data;
        this.activeIndex = res.data[0].id;
        this.money = this.rechargeAmount[0].price;
      });
    },
    handleClickPay() {
      this.requestPay();
    },
    // 银行请求支付
    requestPay() {
      let that = this
      let money;
      if(this.customMoney) {
         money = this.customMoney
      }else {
         money = this.money;
      }
      console.log(money)
      let internetBarId = this.$cookies.get('internetBarId')
      pay({
        price: money,
        internetBarId: internetBarId,
        ipStr: "192.168.1.53"
      }).then(res => {
        if (res.code == 200) {
          console.log(res);
          let data = res.data
          // let data = JSON.parse(res.data);
          let orderNumber = data.OrderNo
          // console.log(data);
          // alert('接受的' + orderNumber)
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.sub_appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.paySign, // 必填，签名，见附录1
            jsApiList: ["chooseWXPay"]
          });
          wx.ready(function() {
            wx.chooseWXPay({
              timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: data.noncestr, // 支付签名随机串，不长于 32 位
              package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
              signType:'RSA', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: data.paySign, // 支付签名
              success: function(res) {  
                that.requestPayState(orderNumber)
              },
              cancel: function(res) {
                Toast("已取消充值");
              },
              fail: function(res) {
                Toast("充值失败，请重新支付");
              }
            });
          });
          // this.requestWxpay()
        }
      });
    },
    requestPayState(orderNumber) {
          // alert('传过去的' + orderNumber)
          payState({orderNumber:orderNumber}).then(res=>{
            console.log(res)
             if(res.code == 200) {
              let data = JSON.stringify(res.data)
              this.$router.push({
               path:'/resultpay',
               query:{
                 data:data
               }
             })
            }
        }) 
     }
  }
};
</script>
<style lang="scss" scoped>
.active {
  background-image: linear-gradient(to right, #05aefc, #008cff);
  color: #ffffff !important;
}
//  标题
.product-pay-title {
  width: 100%;
  height: 55px;
  line-height: 55px;
  padding: 0 13px;
  box-sizing: border-box;
  color: #333333;
  font-size: 16px;
  text-align: left;
  font-weight: bold;
}
// 选择钱list
.product-pay-money {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
  // justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
  .product-pay-money-list {
    width: 106px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid #008cff;
    border-radius: 5px;
    color:#333333;
    font-size: 16px;
    font-weight: bold;
    margin: 15px 3px;
    input {
      width: 75px;
      height: 48px;
      line-height: normal;
      border: none;
      font-size: 14px;
      color:#333333;
      &::-webkit-input-placeholder {
        line-height: normal;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
// 显示支付的钱数
.product-pay-show-money {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 13px;
  box-sizing: border-box;
  color: #333333;
  font-size: 16px;
  text-align: left;
  font-weight: bold;
  span {
    &:first-child {
      color: #008cff;
      font-size: 12px;
    }
    &:last-child {
      color: #008cff;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
// 支付按钮
.pay-btn {
  width: 350px;
  height: 44px;
  background: -webkit-linear-gradient(left, #05aefc, #008cff);
  margin: 0 auto;
  border-radius: 22px;
  font-size: 16px;
  color: $white-color;
  line-height: 44px;
  margin: 37px auto;
  margin-bottom: 10px;
}
// 支付提示
.pay-tip {
  width: 100%;
  color: #999999;
  font-size: 12px;
  padding: 0 17px;
  box-sizing: border-box;
  text-align: left;
  line-height: 1.2;
}
</style>